import React from 'react';
import { XCircle, AlertTriangle, ArrowLeft } from 'lucide-react';
import Footer from './Footer';

const ConsentWithdrawnPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <div className="flex-1 flex items-center justify-center py-12">
                <div className="max-w-md mx-auto text-center px-4">
                <div className="bg-white rounded-lg shadow-md p-8">
                    <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-6" />

                    <h1 className="text-2xl font-bold text-gray-900 mb-4">
                        Consent Declined
                    </h1>

                    <div className="space-y-4 text-left">
                        <div className="bg-orange-50 rounded-md p-4">
                            <div className="flex items-start">
                                <AlertTriangle className="w-5 h-5 text-orange-600 mr-2 mt-0.5" />
                                <div>
                                    <h3 className="font-medium text-orange-800">No Consent Provided</h3>
                                    <p className="text-sm text-orange-700 mt-1">
                                        You have declined to provide D906 consent for licence checking.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2">
                            <div className="text-sm text-gray-600">
                                <strong>What this means:</strong>
                                <ul className="mt-2 space-y-1 text-xs">
                                    <li>• Your employer cannot check your licence status</li>
                                    <li>• This may affect your employment eligibility</li>
                                    <li>• You can provide consent later if needed</li>
                                    <li>• Contact your employer for alternative options</li>
                                </ul>
                            </div>

                            <div className="rounded-md p-3" style={{ backgroundColor: 'rgba(105, 190, 40, 0.1)' }}>
                                <p className="text-xs" style={{ color: '#69BE28' }}>
                                    <strong>Changed your mind?</strong> Contact your employer to request
                                    a new consent form if you'd like to provide consent later.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-200">
                        <p className="text-xs text-gray-500">
                            Your decision has been recorded. No further action is required.
                        </p>
                    </div>
                </div>

                <div className="mt-6">
                    <button
                        onClick={() => window.close()}
                        className="inline-flex items-center text-sm hover:opacity-80 transition-opacity"
                        style={{ color: '#69BE28' }}
                    >
                        <ArrowLeft className="w-4 h-4 mr-1" />
                        Close this window
                    </button>
                </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ConsentWithdrawnPage;